import manifest from './exports.manifest.json';

import type { Plugin } from 'vue';
import type { PluginPackageInitializeModuleOptions } from 'commercial-web-client-utilities/dist/types/common';

async function getVuePlugin(): Promise<Plugin> {
    return (await import('./plugin')).default;
}

async function getInitializeModule(): Promise<(options: PluginPackageInitializeModuleOptions) => Promise<void>> {
    return await (await import('./initialize-module')).default;
}

export { manifest, getVuePlugin, getInitializeModule };